export default {
  color: "#f00",
  weight: 6,
  opacity: 0.75,
  fillColor: "#f00",
  fillOpacity: 0.3,
}
